import { ShieldCheck, Factory, Package, Handshake } from "lucide-react";

const REASONS = [
  {
    icon: ShieldCheck,
    title: "Certified Quality Systems",
    desc: "FSSAI, GMP and AYUSH certifications underpin every batch we manufacture — from raw-material intake to finished pack.",
  },
  {
    icon: Factory,
    title: "In-House Manufacturing",
    desc: "Production runs at our Sonipat facility in Barhi Industrial Area — not outsourced, not brokered. Full operational control.",
  },
  {
    icon: Package,
    title: "Private Label & Bulk",
    desc: "From single-SKU private-label launches to large-volume bulk and contract manufacturing for established brands.",
  },
  {
    icon: Handshake,
    title: "Partner, Not Supplier",
    desc: "Direct, transparent communication from enquiry to dispatch. Quick turnaround on quotes and clear pricing.",
  },
];

export const WhyChooseUs = () => {
  return (
    <section
      data-testid="why-section"
      className="py-24 md:py-32 bg-[#FAFAFA] border-t border-[#E5E5E5]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid md:grid-cols-2 gap-10 items-end mb-14">
          <div>
            <div className="overline">
              <span className="gold-divider mr-3 align-middle" />
              Why White Bull Global
            </div>
            <h2 className="font-serif-display text-4xl md:text-5xl text-[#1A1A1A] mt-6 leading-tight">
              The reasons brands
              <br />
              choose our facility.
            </h2>
          </div>
          <p className="text-[#595959] leading-relaxed md:text-right">
            We keep the list short — only what we can stand behind. No inflated
            numbers, no vague promises. Just what you can actually expect when
            you work with us.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
          {REASONS.map((r, i) => {
            const Icon = r.icon;
            return (
              <div
                key={r.title}
                data-testid={`why-card-${i}`}
                className="bg-white border border-[#E5E5E5] p-7 md:p-8 transition-all hover:border-[#D4AF37]"
              >
                <Icon
                  className="w-7 h-7 text-[#D4AF37]"
                  strokeWidth={1.4}
                />
                <div className="font-serif-display text-xl text-[#1A1A1A] mt-6">
                  {r.title}
                </div>
                <p className="text-sm text-[#595959] mt-3 leading-relaxed">
                  {r.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
